import { Snooze } from '@app/types/api/job';

/**
 * Returns true if the given user currently has an active snooze on a case.
 */
export const isCaseSnoozedForUser = (
  snoozes: Snooze[] | undefined,
  userId: string | undefined,
): boolean =>
  snoozes?.some(
    (s) => s.userId === userId && new Date(s.snoozedUntil) > new Date(),
  ) ?? false;
